module.exports = __webpack_public_path__ + "static/media/market_place.88a20578.svg";